import { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export interface Action {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

interface Props {
  actions: Action[];
  handleClose: () => void;
}

const SimpleActionMenu: React.FC<Props> = ({ actions, handleClose }) => {
  const handleActionClick = (action: Action) => {
    handleClose();
    window.setTimeout(() => {
      action.onClick();
    }, 0);
  };

  return (
    <>
      {actions.map((action, index) => (
        <MenuItem key={`sam-${action.label}-${index}`} disabled={action.disabled ?? false} onClick={() => handleActionClick(action)}>
          {action.icon} {action.label}
        </MenuItem>
      ))}
    </>
  );
};

export default SimpleActionMenu;
